import { useState, useEffect, useRef } from 'react'
import { Box } from '@chakra-ui/react';
import { convertToQuillDelta, isQuillDeltaFormat } from '../../../../global/helpers/global-helpers';
import LaunchdeckInputTextArea from '../../../../forms/TextareaField/components/LaunchdeckInputTextArea';
import LaunchdeckDisplayTextArea from '../../../../forms/TextareaField/components/LaunchdeckDisplayTextArea';


export const NormalText = ({
  subWidgetId,
  editableItemId,
  setSubWidgetContent,
  subWidgetContent,
  isDragging,
  handleEditItemByClick,
  handleSaveItemByClickOutside
}) => {

  const quillRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (subWidgetContent) {
      const isDeltaFormat = isQuillDeltaFormat(subWidgetContent)

      if (!isDeltaFormat && typeof subWidgetContent === "string") {
        const convertedContent = convertToQuillDelta(subWidgetContent)
        setSubWidgetContent(convertedContent)
      }
    }
  }, []);

  const handleClick = () => {
    if (!isDragging) {
      handleEditItemByClick()
      setIsFocused(true)
    }
  }

  const onChangeQuillHandler = (name, contentValue) => {
    if (name === `${subWidgetId}-subwidget`) {
      setSubWidgetContent(contentValue)
    }
  }


  useEffect(() => {
    const handleClickOutside = (event) => {
      if ((isFocused && quillRef.current) && !quillRef?.current.contains(event.target)) {
        setIsFocused(false);
        handleSaveItemByClickOutside();
      }
    };

    if (isFocused) {
      setTimeout(() => window.addEventListener('mousedown', handleClickOutside), 1)
    } else {
      window.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFocused]);

  return (
    editableItemId === subWidgetId
      ? <Box width="100%" ref={quillRef} style={{ cursor: "pointer" }}>
        <LaunchdeckInputTextArea
          name={`${subWidgetId}-subwidget`}
          onChangeHandler={onChangeQuillHandler}
          defaultDelta={subWidgetContent}
          placeholder={"Add your text content here"}
          backgroundColor='white'
          isFocused={isFocused}
        />

      </Box>
      : <Box onClick={handleClick} maxW="780px" w='100%'>
        <LaunchdeckDisplayTextArea deltaContent={subWidgetContent} cursor='pointer' />
      </Box>
  )
}
